/**
 * Lowercases the ASCII letters of a URL path.
 *
 * Every page is published under its lowercase path (getTranslatedSlugs() in
 * ./translatedSlugs.ts, enforced by gatsby/assertLowercasePagePaths.ts) and the
 * CloudFront viewer-request function in the infrastructure repository redirects
 * any other spelling to it. Every URL the site emits for a page (links,
 * canonical and hreflang tags, sitemap entries, structured data) goes through
 * this helper so it points at the published path directly.
 *
 * Only A-Z in the path is touched, like the CloudFront function does:
 * percent-escapes and non-ASCII characters keep their case, and so do a query
 * string and an anchor (element ids are case-sensitive). Deciding what must not
 * be lowercased at all (documentation, assets, external URLs) is up to the
 * caller.
 */
export const toLowercasePath = (path: string): string => {
  const end = path.search(/[?#]/)
  const pathname = end === -1 ? path : path.slice(0, end)
  const rest = end === -1 ? '' : path.slice(end)

  return (
    pathname.replace(/%[0-9A-Fa-f]{2}|[A-Z]+/g, match => (match.startsWith('%') ? match : match.toLowerCase())) + rest
  )
}
